import { RuleObject, ValidatorRule } from "rc-field-form/lib/interface"

export const USDPricePattern = /^(?!0{2,})\d+(\.(\d){0,2}?)?$/
export const NumberPattern = /^(?!0{2,})\d+(\.(\d){0,999}?)?$/

export const urlPattern =
  /^(https?|ftp):\/\/(([a-z\d]([a-z\d-]*[a-z\d])?\.)+[a-z]{2,}|localhost)(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i

export const numberValidator: ValidatorRule["validator"] = (
  _: any,
  value: string | string[],
) => {
  if (Array.isArray(value)) {
    value.forEach((item): Promise<any> | void => {
      if (!Number.isInteger(+item)) {
        return Promise.reject(new Error("Please input number"))
      }
    })

    return Promise.resolve()
  }

  return Number.isInteger(+value)
    ? Promise.resolve()
    : Promise.reject(new Error("Please input number"))
}

export const floatValidator: ValidatorRule["validator"] = (
  { message, required }: RuleObject,
  value: string,
) => {
  const present = !!value && value.length > 0

  if (present || required) {
    if (!USDPricePattern.test(value[value.length - 1] as string)) {
      return Promise.reject(message)
    }
  }

  return Promise.resolve()
}

export const zeroValidator: ValidatorRule["validator"] = (
  { message, required }: RuleObject,
  value: string,
) => {
  const present = !!value && value.length > 0

  if (present || required) {
    if (Number(value) === 0) {
      return Promise.reject(message)
    }
  }

  return Promise.resolve()
}
